import Image from 'next/image';
import clsx from 'clsx';

export default async function LogoHeadline({ block, position, entry_uid }) {
  const { logo, description, background_color_picker, text_color } =
    block.logo_headline;

  return (
    <section
      id={entry_uid + '_' + position}
      data-name="logo-headline"
      className={clsx(
        'hero-content-logo-headline w-full px-5 py-20 text-center sm:px-15 lg:px-30 lg:py-30',
        background_color_picker && `bg-[${background_color_picker}]`,
        text_color && `text-[${text_color}]`
      )}
    >
      {logo.url && (
        <h1>
          <Image
            src={logo.url}
            alt={logo.title}
            width="428"
            height="40"
            sizes="428px"
            className="mx-auto mb-5 max-h-5 sm:max-h-8 lg:mb-10 lg:max-h-10"
          />
        </h1>
      )}
      {description && (
        <p className="body-r sm:body-l lg:sh8 mx-auto max-w-160">
          {description}
        </p>
      )}
    </section>
  );
}
